// Media queries centralisées pour une utilisation cohérente dans toute l'application
const mediaQueries = {
  small: '@media (max-width: 480px)',
  medium: '@media (max-width: 768px)',
  large: '@media (max-width: 1024px)',
};

export default mediaQueries;